import React from 'react';

export default function AddressBlock (props) {
    let {name, address} = props;
    if (!address.street || !address.street.length) {
        return <div>No Address</div>;
    }
    return (<div vocab="http://schema.org/" typeof="Person">
        {address.attn && <div>ATTN: {address.attn}</div>}
        {name && <div property="name">{name}</div>}
        <div property="address" typeof="PostalAddress">
            {address.street.map((line, i) => {
                return (<div property="streetAddress" key={`street_${i}`}>{line}</div>);
            })}
            <span property="addressLocality">{address.city}</span> <span property="addressRegion">{address.region.substring(3, 5)}</span> <span property="postalCode">{address.postal_code}</span> <span>{address.country}</span>
        </div>
    </div>);
}
